var SENTRY_RELEASE;SENTRY_RELEASE={name: "SQUIRE", version: "3.22.0"};